import {
    Box,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

function GruppeErstellenDialog({ open, onClose, neuGruppe, onNeuGruppe, onCreate }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Neue Gruppe erstellen</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        label="Gruppenname"
                        value={neuGruppe.name}
                        onChange={(e) => onNeuGruppe({ ...neuGruppe, name: e.target.value })}
                        fullWidth
                        required
                        autoFocus
                    />
                    <TextField
                        label="Beschreibung (optional)"
                        value={neuGruppe.beschreibung}
                        onChange={(e) => onNeuGruppe({ ...neuGruppe, beschreibung: e.target.value })}
                        fullWidth
                        multiline
                        rows={3}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button onClick={onCreate} variant="contained">
                    Erstellen
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default GruppeErstellenDialog;
